module.exports = __WEBPACK_EXTERNAL_MODULE_34__;


//////////////////
// WEBPACK FOOTER
// external "underscore"
// module id = 34
// module chunks = 0